module.exports = __webpack_public_path__ + "static/media/20ECE28.817bad72.jpg";